import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { IMapStateToProps } from '../../getaway';
import { IAccount } from '@share/common-types';
import { isEmpty } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
interface GuestsRoomsSelectorProps {
  rooms: any;
  setRooms: (newRooms: any) => void;
  setIsRoomSelect?: (value: boolean) => void;
  isLoading? : boolean
  setDisable: any
}
interface Room {
  adultsCount: number;
  kidsAges: number[];
}

const GuestsRoomsSelector: React.FC<GuestsRoomsSelectorProps> = ({
  rooms,
  setRooms,
  setDisable,
  setIsRoomSelect,
  isLoading,
}) => {
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const account  = login.account as IAccount;
  const color: any = account?.searchIconsColor;
  const styleColor = !isEmpty(color) ? { color } : {};
  const location = useLocation();
  const path = location.pathname;
  const dashboardPath = path.split('/').slice(2).join('/');
  const handleUpdateRoom = (index, newData) => {
    const newRooms = [...rooms];
    newRooms[index] = newData;
    setRooms(newRooms);
  };

  const handleAddRoom = () => {
    setRooms([...rooms, { adultsCount: 1, kidsAges: [] }]);
    setDisable(false);
  };

  const handleRemoveRoom = (indexToRemove) => {
    setRooms(rooms.filter((_, index) => index !== indexToRemove));
    setDisable(false);
  };

  const handleAdultChange = (roomIndex, increment) => {
    const newRooms = [...rooms];
    const newCount = increment
      ? newRooms[roomIndex].adultsCount + 1
      : newRooms[roomIndex].adultsCount - 1;
    newRooms[roomIndex].adultsCount = newCount;
    setRooms(newRooms);
    setDisable(false);
  };

  const handleKidAgeChange = (roomIndex, kidIndex, age) => {
    const newRooms = [...rooms];
    newRooms[roomIndex].kidsAges[kidIndex] = age;
    setRooms(newRooms);
    setDisable(false);
  };

  const addKid = (roomIndex) => {
    const newRooms = [...rooms];
    newRooms[roomIndex].kidsAges.push(1);
    setRooms(newRooms);
    setDisable(false);
  };

  const subtractKid = (roomIndex) => {
    const newRooms = [...rooms];
    if (newRooms[roomIndex].kidsAges.length > 0) {
      newRooms[roomIndex].kidsAges.pop();
      setRooms(newRooms);
      setDisable(false);
    }
  };

  const removeKid = (roomIndex, kidIndex) => {
    const newRooms = [...rooms];
    newRooms[roomIndex].kidsAges = newRooms[roomIndex].kidsAges.filter((_, i) => i !== kidIndex);
    setRooms(newRooms);
    setDisable(false);
  };

  const intl = useIntl();

  const totalAdults = rooms.reduce((acc, room) => acc + room.adultsCount, 0);
  const totalRooms = rooms.length;
  const totalKids = rooms.reduce((total, room) => total + room.kidsAges.length,0);

  const guestSummary = `${totalAdults} ${intl.formatMessage({ id: 'adults' })}, ${totalRooms} ${intl.formatMessage({ id: totalRooms === 1 ? 'room.title' : 'rooms' })}${totalKids > 0 ? `, ${totalKids} ${intl.formatMessage({ id: 'kids' })}` : ''}`;

  return (
    <div className='w-100 hotelLocation position-relative'>
      <div className="hotelLocation_wrap">
        <div className='hotelLocation_left' style={styleColor}>
          <i className="bi bi-people fa-fw"></i>
        </div>
        <div className="w-100">
          <div className='hotelLocation_right'>
            <label className="hotelLocation_right_label form-control-border m-0 form-label"><FormattedMessage id="dashboard.guests.rooms" /></label>
            <div className='hotelLocation_right_input'>
              <div className="dropdown guest-selector relative">
              <input
                type="text"
                className="form-guest-selector form-control selection-result"
                value={guestSummary}
                data-bs-auto-close="outside"
                data-bs-toggle="dropdown"
                readOnly
              />

              <ul className="dropdown-menu dropdown-menu-block guest-selector-dropdown">
                {rooms.map((room, roomIndex) => (
                  <div key={roomIndex}>
                    <div className="room-container">
                      <p><FormattedMessage id="rooms" />: {roomIndex + 1}</p>
                      {roomIndex === 0 ? (
                        ''
                      ) : (
                        <button
                          className="btn btn-link kid-remove p-0 d-flex justify-content-center align-content-center align-items-center "
                          onClick={() => handleRemoveRoom(roomIndex)}
                        >
                          <FormattedMessage id="remove" />
                          <i className={`ms-1 bi bi-dash-circle fs-5 fa-fw ${!styleColor && 'btn-bi-color'}`} style={styleColor}></i>
                          {/* <i className="bi bi-dash-circle fs-5 fa-fw btn-bi-color" style={styleColor}></i> */}
                        </button>
                      )}
                    </div>

                    <li className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0"><FormattedMessage id="adults" /></h6>
                        <small><FormattedMessage id="adults.age" /></small>
                      </div>

                      <div className="hstack gap-1 align-items-center">
                        <button
                          type="button"
                          className="btn btn-link adult-remove p-0 mb-0 btn-bi-color"
                          onClick={() => handleAdultChange(roomIndex, false)}
                          disabled={room.adultsCount <= 1}
                        >
                          <i className="bi bi-dash-circle fs-5 fa-fw" style={styleColor}></i>
                        </button>
                        <h6 className="guest-selector-count mb-0 adults">{room.adultsCount}</h6>
                        <button
                          type="button"
                          className="btn btn-link adult-add p-0 mb-0 btn-bi-color"
                          onClick={() => handleAdultChange(roomIndex, true)}
                        >
                          <i className="bi bi-plus-circle fs-5 fa-fw" style={styleColor}></i>
                        </button>
                      </div>
                    </li>

                    <li className="d-flex justify-content-between mt-2">
                      <div>
                        <h6 className="mb-0"><FormattedMessage id="children" /></h6>
                        <small><FormattedMessage id="children.age" /></small>
                      </div>

                      <div className="hstack gap-1 align-items-center">
                        <button
                          type="button"
                          className="btn btn-link room-remove p-0 mb-0 btn-bi-color"
                          onClick={() => subtractKid(roomIndex)}
                        >
                          <i className="bi bi-dash-circle fs-5 fa-fw" style={styleColor}></i>
                        </button>
                        <h6 className="guest-selector-count mb-0 rooms">{room.kidsAges.length}</h6>
                        <button
                          type="button"
                          className="btn btn-link kid-add p-0 mb-0 btn-bi-color"
                          onClick={() => addKid(roomIndex)}
                        >
                          <i className="bi bi-plus-circle fs-5 fa-fw" style={styleColor}></i>
                        </button>
                      </div>
                    </li>

                    {room.kidsAges.map((age, kidIndex) => (
                      <li
                        key={kidIndex}
                        className="d-flex justify-content-between align-items-center mt-2"
                      >
                        <div>
                          <h6 className="mb-0 kids-age"><FormattedMessage id="kid.age" values={{ age: kidIndex + 1 }} /></h6>
                        </div>

                        <div className="hstack gap-1 align-items-center">
                          <select
                            defaultValue={1}
                            value={age}
                            onChange={(e) =>
                              handleKidAgeChange(roomIndex, kidIndex, parseInt(e.target.value, 10))
                            }
                            className="form-control-kidAges"
                          >
                            {Array.from({ length: 17 }, (_, i) => (
                              <option key={i} value={i + 1}>
                                {i + 1}
                              </option>
                            ))}
                          </select>
                          <button
                            type="button"
                            className="btn btn-link kid-remove p-0 mb-0"
                            onClick={() => removeKid(roomIndex, kidIndex)}
                          >
                            <i className="bi bi-dash-circle fs-5 fa-fw" style={styleColor}></i>
                          </button>
                        </div>
                      </li>
                    ))}
                    <li className="dropdown-divider"></li>
                  </div>
                ))}
                <li className=" d-flex justify-content-start align-content-center mb-1">
                  <button
                    className="btn btn-link adult-add p-0 m-0  d-flex justify-content-end align-content-center align-items-center"
                    onClick={handleAddRoom}
                  >
                    <i className={`bi bi-plus-circle fs-5 fa-fw me-1 ${!styleColor && 'btn-bi-color'}`} style={styleColor}></i>
                    <FormattedMessage id="add.room" />
                  </button>
                </li>
                {dashboardPath !== 'dashboard' && <li className=" d-flex justify-content-start align-content-center">
                  <button
                    className="btn btn-link adult-add p-0 m-0  d-flex justify-content-end align-content-center align-items-center"
                    onClick={() => setIsRoomSelect(true)}
                    disabled={isLoading}
                  >
                    <i className="bi bi-filter fs-5 fa-fw btn-bi-color me-1"></i>
                    <FormattedMessage id="apply.filter" />(s)
                  </button>
                </li>}
              </ul>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
  );
};

export { GuestsRoomsSelector };
